import { useEffect, useState } from "react";
import api from "./api";

// Cross-component cache so we hit /billing/features once per session.
let _cache = null;
let _inflight = null;

export function useFeatures() {
  const [features, setFeatures] = useState(_cache);

  useEffect(() => {
    if (_cache) { setFeatures(_cache); return; }
    if (!_inflight) {
      _inflight = api.get("/billing/features").then((r) => { _cache = r.data; return r.data; }).catch(() => ({ plan: null, features: {} }));
    }
    _inflight.then((d) => setFeatures(d));
  }, []);

  return {
    plan: features?.plan,
    planName: features?.plan_name,
    can: (name) => !features || !!features.features?.[name],
    loaded: !!features,
  };
}
